<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Quote/Default">
      <path id="Vector" d="M9.375 6.42578H2.625V14.6758C2.625 19.9258 6.375 21.4258 9.375 20.6758C7.125 18.4258 7.125 16.9258 7.125 14.6758H9.375V6.42578ZM19.875 6.42578H13.125V14.6758C13.125 19.9258 16.875 21.4258 19.875 20.6758C17.625 18.4258 17.625 16.9258 17.625 14.6758H19.875V6.42578Z" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>
